export default __webpack_public_path__ + "static/media/bg8.e868e4aa.png";